module.exports = __webpack_public_path__ + "static/media/a7.5396763.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dengyunze/a7.mp3
// module id = aAKa
// module chunks = 0